import React from 'react';
import logo from 'images/RR_Logo_Lsp2.png';

import './unauthorized.style.css';

const Unauthorized = () => (
    <div className="UnauthorizedWrapper">
        <div className="UnauthorizedContainer">
            <div className="Unauthorized">
                <div className="UnauthorizedContent">
                    <img alt="Right Revenue Logo" src={logo} />
                    <h1>Access Denied</h1>
                    <p>Sorry, you do not have permission to access this resource.</p>
                    <br />
                    <a href="/" role="button" className="UnauthorizedButton">
                        Log into the application
                    </a>
                </div>
            </div>
        </div>
    </div>
);

export default Unauthorized;
